import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=27dcfa2c&scoped=true&lang=pug&"
import script from "./loginPage.vue?vue&type=script&lang=js&"
export * from "./loginPage.vue?vue&type=script&lang=js&"
import style0 from "./loginPage.vue?vue&type=style&index=0&id=27dcfa2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dcfa2c",
  null
  
)

export default component.exports